/**
 * Updates the value of a card in the cards array
 * @param {Array} cards
 * @param {number} delta
 * @param {number} index
 * @param {number} [unassignedCredits=0]
 * @returns {Array} Updated cards array
 */
export const updateCardValue = (cards, delta, index, unassignedCredits = 0) => {
  const updated = [...cards];
  const card = updated[index];

  if (!card) return cards;

  if (delta > 0 && unassignedCredits > 0) {
    updated[index] = { ...card, value: card.value + 1 };
  } else if (delta < 0 && card.value > 0) {
    updated[index] = { ...card, value: card.value - 1 };
  }

  return updated;
};
